import { render, staticRenderFns } from "./chooseResourceStore.vue?vue&type=template&id=622d4d92&scoped=true"
import script from "./chooseResourceStore.vue?vue&type=script&lang=js"
export * from "./chooseResourceStore.vue?vue&type=script&lang=js"
import style0 from "./chooseResourceStore.vue?vue&type=style&index=0&id=622d4d92&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_29ccf6a1548590c1291b44f0faebdb79/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "622d4d92",
  null
  
)

export default component.exports